import { useParams } from 'react-router-dom'
import { useGoToStorageScanDestinationDetail } from '../scan-destination/StorageScanDestination.navigator'
import { useEffect, useState } from 'react'
import { type ProductWithAlertInfo } from 'types/model'
import { useAtom } from 'jotai'
import { toast } from 'react-toastify'
import { getActiveProductsFromSuggestion } from 'client/alerts/alerts.client'
import { productsInContainerReader, selectedProductsAtom } from '../Storage.state'

export const useContainerDetail = () => {

  const scanDestination = useGoToStorageScanDestinationDetail()

  const [selected, setSelected] = useState<ProductWithAlertInfo[]>([])
  const [products, setProducts] = useState<ProductWithAlertInfo[]>([])
  const [isLoading, setIsLoading] = useState(false)

  const [, setSelectedInventoryProducts] = useAtom(selectedProductsAtom)
  const [productsInContainer] = useAtom(productsInContainerReader)

  const params = useParams()
  const containerName: string = params.containerName ?? 'INVALID_CONTAINER_NAME'

  // On Init: find products and alerts
  useEffect(() => {
    setIsLoading(true)
      getActiveProductsFromSuggestion({suggestion:containerName})
      .then(async (alerts) => {
        const mappedProducts = productsInContainer.map((it): ProductWithAlertInfo => {
          const alert = alerts.find((a) => a.productEan === it.ean)?.level ?? 'None'
          return { ...it, alert }
        })
        setProducts(mappedProducts)
      })
      .catch((err: Error) => {
        toast.error(err.message)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  return {
    products,
    selectedInventoryProducts: selected,
    isLoading,
    actions: {
      continue: () => {
        setSelectedInventoryProducts(selected)
        scanDestination.go(
          containerName,
          'move-products'
        )
      },
      toggleInventoryProduct: (inventoryProduct: ProductWithAlertInfo) => {
        if (selected.find((e) => e.ean === inventoryProduct.ean)) {
          setSelected((s) => s.filter((x) => x.ean !== inventoryProduct.ean))
        } else {
          setSelected((s) => s.concat(inventoryProduct))
        }
      },
      selectAllInventoryProducts: () => {
        setSelected(products)
      },
      clearSelectedInventoryProducts: () => {
        setSelected([])
      }
    }
  }
}
